import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Document} from "app/archivage/common/services/document/document.model";
import {UntypedFormBuilder, UntypedFormArray} from "@angular/forms";

@Component({
  selector: 'app-edit-doc',
  templateUrl: './edit-doc.component.html',
  styleUrls: ['./edit-doc.component.scss']
})
export class EditDocComponent implements OnInit {
  entity: number;
  tmpForm: UntypedFormArray;

  constructor(
    public dialogRef: MatDialogRef<EditDocComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Document,
    private formBuilder: UntypedFormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.entity = this.data.dir_cmp_archive_obj.id;
    this.tmpForm = this.formBuilder.array([]);
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    const duaSelected = this.tmpForm.value[0].duaSelected;
    console.log('EditDocComponent dua old: ', this.data.dua, ' new: ', duaSelected);
    if (duaSelected !== this.data.dua) {
      this.data.dua = duaSelected;
      this.dialogRef.close(this.data);
    } else {
      this.cancel();
    }
  }
}
